import React, {Component} from 'react';
import {Map, Marker, CircleMarker, Pane, TileLayer, Tooltip, ZoomControl, GeoJSON} from 'react-leaflet';

import debounce from 'lodash.debounce';

import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as GTFSActions from 'ducks/gtfs';
import * as MapActions from 'ducks/map';

import L from 'leaflet';
import 'leaflet.icon.glyph';

import api from 'utils/api';
import StopPopup from "./StopPopup";

const mapStateToProps = state => ({
    trip: state.gtfs.trips[state.gtfs.activeTrip],
    map: state.map,
});

const mapDispatchToProps = dispatch => bindActionCreators({...GTFSActions, ...MapActions}, dispatch);


@connect(mapStateToProps, mapDispatchToProps)
export default class TransitMap extends Component {
    state = {
        showStopNames: false,
        stops: [],
        socket: null,
        realTime: [],
        userLocation: null,
    };

    stopIcon = L.icon.glyph({
        prefix: '',
        glyph: 'A',
    });

    componentDidMount = () => {
        const socket = new WebSocket(`${DJ_CONST.WS_URL}/realtime`);
        socket.onmessage = realTime => {
            // console.log(realTime.data);
            //this.setState({realTime})
        };

        this.setState({socket});

        api.stops.fetch(null, {zone_name: "Harju1"}).then(stops => {
            this.setState({stops});
        });
    };

    componentWillUnmount = () => {
        this.state.socket.close();
    };

    onViewportChanged = (viewport) => {
        // If the map is zoomed in, we don't need to fetch new stops, because we already have everything.
        const zoomedIn = this.props.map.viewport.zoom < viewport.zoom;
        this.setViewport(viewport);
        this.setState({
            showStopNames: viewport.zoom >= 15,
        }, () => {
            if (!zoomedIn) {
                this.fetchStops();
            }
        });
    };

    setViewport = debounce((viewport) => {
        this.props.setViewport(viewport);
    }, 1000);

    fetchStops = debounce(() => {
        const latLngBounds = this.map.leafletElement.getBounds();
        const query = {
            'stop_lat__gte': latLngBounds.getSouth(),
            'stop_lat__lte': latLngBounds.getNorth(),
            'stop_lon__gte': latLngBounds.getWest(),
            'stop_lon__lte': latLngBounds.getEast(),
        };

        api.stops.fetch(null, query).then(stops => {
            this.setState({stops});
        });
    }, 1000);

    locateUser = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((pos) => {
                this.props.setUserLocation(pos);
                this.props.setViewport({
                    center: {
                        lat: pos.coords.latitude,
                        lng: pos.coords.longitude,
                    },
                    zoom: 15,
                });
            }, (err) => {
                console.log(err);
                this.props.setUserLocation(null);
            }, {
                enableHighAccuracy: true,
            });
        }
    };

    onMapReady = () => {
        this.locateUser();
    };

    renderTrip = () => {
        const {trip} = this.props;

        if (!trip) {
            return null;
        }

        const routeShape = {
            "type": "FeatureCollection",
            "features": [
                {
                    "type": "Feature",
                    "properties": {
                        "name": "Liin 21A",
                        "popupContent": "Väike-Õismäe - Kakumäe",
                    },
                    "geometry": {
                        "type": "LineString",
                        "coordinates": trip ? trip.coordinates : [],
                    }
                }
            ]
        };

        return (<GeoJSON key={trip.shape_id} data={routeShape} style={{color: "red"}} />);
    };

    renderUserLocation = () => {
        const {userLocation} = this.props.map;

        if (!userLocation) {
            return null;
        }

        return (
            <CircleMarker
                center={{lat: userLocation.coords.latitude, lng: userLocation.coords.longitude}}
                radius={4}
                weight={2}
                opacity={1}
                color="#ad2699"
                fillOpacity={1}
                fillColor="#ffffff"
            />
        );
    };

    render() {
        const {viewport} = this.props.map;
        const {stops} = this.state;

        const validStops = stops.filter(stop => stop.stop_lat && stop.stop_lon);
        return (
            <Map
                ref={map => { this.map = map; }}
                className="map"
                viewport={viewport}
                zoomControl={false}
                onViewportChanged={this.onViewportChanged}
                whenReady={this.onMapReady}
            >
                <ZoomControl position="topright" />
                <TileLayer
                    attribution="&amp;copy <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
                    url="https://api.mapbox.com/styles/v1/mapbox/streets-v10/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1Ijoia2FzcGFyOTIiLCJhIjoiTlRMcDJrZyJ9.mj8_A3rJjTHMJSNHjQeCIQ"
                />
                {validStops.map(stop => (
                    <CircleMarker
                        key={stop.stop_id}
                        center={{lat: parseFloat(stop.stop_lat), lng: parseFloat(stop.stop_lon)}}
                        radius={4}
                        weight={2}
                        opacity={1}
                        color="#3388ff"
                        fillOpacity={1}
                        fillColor="#ffffff"
                    >
                        <Tooltip className="tooltip" opacity={0.7}>
                            <span>{stop.stop_name}</span>
                        </Tooltip>
                        <StopPopup stop={stop} />
                    </CircleMarker>
                ))}
                {this.renderUserLocation()}
                {this.renderTrip()}
            </Map>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/TransitMap.js